import React, { useState, useEffect } from 'react';
import {
    Drawer, Box, Typography, Button, IconButton, Chip, Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const roleOptions = [
    { value: 'All', label: 'All Roles' },
    { value: 'admin', label: 'Admin' },
    { value: 'user', label: 'User' },
];

const verificationOptions = [
    { value: 'All', label: 'All Statuses' },
    { value: 'verified', label: 'Verified' },
    { value: 'not_verified', label: 'Not Verified' },
];

const AdminUserFilterDrawer = ({ open, onClose, selectedRole, selectedStatus, onApplyFilters }) => {
    const [currentRole, setCurrentRole] = useState(selectedRole || 'All');
    const [currentStatus, setCurrentStatus] = useState(selectedStatus || 'All');

    useEffect(() => {
        if (open) {
            setCurrentRole(selectedRole || 'All');
            setCurrentStatus(selectedStatus || 'All');
        }
    }, [selectedRole, selectedStatus, open]);

    const handleApply = () => {
        onApplyFilters(currentRole, currentStatus);
        onClose();
    };

    const handleClear = () => {
        setCurrentRole('All');
        setCurrentStatus('All');
    };

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            keepMounted={false}
            disableRestoreFocus={true}
            PaperProps={{ sx: { width: { xs: '100%', sm: 380 } } }}
        >
            <Box sx={{ p: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                    Filters
                </Typography>
                <IconButton onClick={onClose} aria-label="close">
                    <CloseIcon />
                </IconButton>
            </Box>
            <Divider />
            <Box sx={{ p: 3, flexGrow: 1, overflowY: 'auto' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                    Role
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 4 }}>
                    {roleOptions.map(option => (
                        <Chip
                            key={option.value}
                            label={option.label}
                            onClick={() => setCurrentRole(option.value)}
                            sx={{
                                fontWeight: 500,
                                borderRadius: '16px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                                border: '1px solid transparent',
                                p: '12px 8px',
                                bgcolor: currentRole === option.value ? '#2563EB' : 'rgba(0, 0, 0, 0.05)',
                                color: currentRole === option.value ? 'white' : 'text.primary',
                                '&:hover': {
                                    bgcolor: currentRole === option.value ? '#1D4ED8' : 'rgba(0, 0, 0, 0.08)',
                                },
                            }}
                        />
                    ))}
                </Box>

                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                    Verification Status
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 4 }}>
                    {verificationOptions.map(option => (
                        <Chip
                            key={option.value}
                            label={option.label}
                            onClick={() => setCurrentStatus(option.value)}
                            sx={{
                                fontWeight: 500,
                                borderRadius: '16px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                                border: '1px solid transparent',
                                p: '12px 8px',
                                bgcolor: currentStatus === option.value ? '#2563EB' : 'rgba(0, 0, 0, 0.05)',
                                color: currentStatus === option.value ? 'white' : 'text.primary',
                                '&:hover': {
                                    bgcolor: currentStatus === option.value ? '#1D4ED8' : 'rgba(0, 0, 0, 0.08)',
                                },
                            }}
                        />
                    ))}
                </Box>
            </Box>
            <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0', bgcolor: 'background.paper', boxShadow: '0 -2px 10px rgba(0,0,0,0.05)' }}>
                <Button
                    fullWidth
                    variant="outlined"
                    onClick={handleClear}
                    size="large"
                    sx={{
                        mb: 2,
                        borderColor: 'text.secondary',
                        color: 'text.secondary',
                        '&:hover': {
                            borderColor: 'text.primary',
                            color: 'text.primary',
                        },
                        py: 1.5,
                        fontWeight: 'bold',
                        borderRadius: 3,
                        textTransform: 'none',
                        fontSize: '1rem'
                    }}
                >
                    Clear All
                </Button>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleApply}
                    size="large"
                    sx={{
                        bgcolor: '#2563EB',
                        '&:hover': { bgcolor: '#1D4ED8' },
                        py: 1.5,
                        fontWeight: 'bold',
                        borderRadius: 3,
                        textTransform: 'none',
                        fontSize: '1rem'
                    }}
                >
                    Apply Filters
                </Button>
            </Box>
        </Drawer>
    );
};

export default AdminUserFilterDrawer; 